"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const fiveLayouts = [
    {
        id: art_layout_names_1.default.CINQUE_PORTRAIT,
        displayName: 'Cinque',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4168126094570928,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.1234676007005254,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.23905429071803852,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.35464098073555167,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.4702276707530648,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.5858143607705779,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.38178633975481613,
                            y: 0.1777583187390543,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.38178633975481613,
                            y: 0.3415061295971979,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.38178633975481613,
                            y: 0.5052539404553416,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5096322241681261,
                            y: 0.2600700525394046,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5096322241681261,
                            y: 0.4238178633975482,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.05253940455341506,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.30998248686514884,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.5674255691768827,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.18126094570928197,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.43870402802101577,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_ORGANIC,
        displayName: 'Organic',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.35288966725043786,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.39842381786339753,
                            y: 0.35376532399299476,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4903677758318739,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.28546409807355516,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.34938704028021017,
                            y: 0.329246935201401,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.07180385288966724,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.47723292469352013,
                            y: 0.329246935201401,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_VERTICAL,
        displayName: 'Vertical',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5569176882661997,
                            y: 0.3134851138353765,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5928196147110333,
                            y: 0.1978984238178634,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5928196147110333,
                            y: 0.47723292469352013,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6847635726795096,
                            y: 0.26970227670753066,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6847635726795096,
                            y: 0.38528896672504376,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.28458844133099825,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.12084063047285463,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.542031523642732,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.23204903677758318,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.3957968476357268,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.2679509632224168,
                            y: 0.3371278458844133,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.36427320490367776,
                            y: 0.28546409807355516,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46059544658493873,
                            y: 0.2329246935201401,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5569176882661997,
                            y: 0.18126094570928197,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6532399299474606,
                            y: 0.1287215411558669,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3073555166374781,
                            y: 0.3966725043782837,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.40367775831873903,
                            y: 0.29422066549912435,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4798598949211909,
                            y: 0.1725043782837128,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5376532399299475,
                            y: 0.29422066549912435,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5761821366024519,
                            y: 0.12171628721541156,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.10595446584938704,
                            y: 0.4991243432574431,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.24080560420315236,
                            y: 0.3239929947460595,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.39929947460595444,
                            y: 0.15236427320490367,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4413309982486865,
                            y: 0.3248686514886165,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5332749562171629,
                            y: 0.05516637478108581,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_GRID,
        displayName: 'Grid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3388791593695274,
                            y: 0.37740805604203154,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3957968476357276,
                            y: 0.2329246935201401,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45359019264448347,
                            y: 0.37740805604203154,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5105078809106838,
                            y: 0.2329246935201401,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5683012259194395,
                            y: 0.37740805604203154,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2714535901926445,
                            y: 0.38528896672504376,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.35113835376532476,
                            y: 0.18126094570928197,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4308231173380035,
                            y: 0.38528896672504376,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5105078809106838,
                            y: 0.18126094570928197,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5901926444833625,
                            y: 0.38528896672504376,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.14448336252189142,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2670753064798599,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.51138353765324,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_BLOCKS,
        displayName: 'Blocks',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5236427320490368,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5236427320490368,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5700525394045534,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6155866900175131,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6155866900175131,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.13134851138353765,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.45884413309982486,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.563922942206655,
                            y: 0.29509632224168125,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.13134851138353765,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.45884413309982486,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5954465849387041,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.29597197898423816,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.4404553415061296,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.33887915936952717,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5910683012259195,
                            y: 0.29597197898423816,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5910683012259195,
                            y: 0.4404553415061296,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.22942206654991243,
                            y: 0.20052539404553416,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.22942206654991243,
                            y: 0.404553415061296,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3887915936952699,
                            y: 0.2434325744308231,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.20052539404553416,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.404553415061296,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_CLOUD,
        displayName: 'Cloud',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.47197898423817863,
                            y: 0.26970227670753066,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5166374781085814,
                            y: 0.12521891418563924,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5166374781085814,
                            y: 0.47373029772329245,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6313485113835376,
                            y: 0.15148861646234676,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6313485113835376,
                            y: 0.47373029772329245,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_WAVE,
        displayName: 'Wave',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DINING_LAYOUTS,
                tiles: [
                    {
                        id: 'dining_5_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.11471103327495621,
                            y: 0.1777583187390543,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'dining_5_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.22942206654991243,
                            y: 0.14798598949211908,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'dining_5_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.08844133099824869,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'dining_5_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.14798598949211908,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'dining_5_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7924693520140105,
                            y: 0.1777583187390543,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FIVE_SQUARE,
        displayName: 'Cinque',
        sets: [{
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'square_8x8_5_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5683012259194394,
                            y: 0.38266199649737304,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_5_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.45359019264448325,
                            y: 0.38266199649737304,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_5_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5105078809106837,
                            y: 0.2679509632224168,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_5_4',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.33887915936952717,
                            y: 0.38266199649737304,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_5_5',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.39579684763572737,
                            y: 0.2679509632224168,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'square_12x12_5_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5901926444833625,
                            y: 0.38266199649737304,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_5_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4308231173380035,
                            y: 0.38266199649737304,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_5_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5105078809106838,
                            y: 0.22329246935201402,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_5_4',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2714535901926445,
                            y: 0.38266199649737304,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_5_5',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.35113835376532476,
                            y: 0.22329246935201402,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_5_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_5_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.51138353765324,
                            y: 0.138353765323993,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_5_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_5_4',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.2670753064798599,
                            y: 0.138353765323993,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_5_5',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.14448336252189142,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    }
                ]
            }]
    }
];
exports.default = fiveLayouts;
//# sourceMappingURL=five.js.map